<template>
  <div
    v-if="data?.onDisallowList"
    class="border-red bg-red flex gap-2 rounded-r-md border-l-4 bg-opacity-10 px-3 py-2 text-sm"
    role="alert"
  >
    <IconHeroiconsSolidNoSymbol
      class="text-red mt-0.5 h-4 w-4 shrink-0"
      aria-hidden="true"
    />
    <div class="min-w-0">
      <p class="text-red font-medium">
        On the Disallow List. The barrier won't open.
      </p>
      <p
        v-if="data.note"
        class="text-background-fg/70 mt-0.5 whitespace-pre-line break-words"
      >
        {{ data.note }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ registration: string }>();

const { data } = useDisallowCheck(toRef(props, "registration"));
</script>
